import React from 'react';
import { t } from 'i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import { IconName } from '@lib/components/Modal/enums';

interface WidgetsEditEmptyStateProps {
  isDefault: boolean;
  onAddWidget: () => void;
}

export default function WidgetsEditEmptyState({
  isDefault,
  onAddWidget,
}: WidgetsEditEmptyStateProps) {
  const actions = [
    <Button
      key="add-widget"
      buttonText={t('add-widget')}
      buttonType={ButtonTypes.secondaryOutlined}
      leftIcon="add"
      onClick={onAddWidget}
    />,
  ];

  const title = isDefault
    ? t('home.empty-state-title')
    : t('home.custom-empty-state-title');

  const text = isDefault
    ? t('home.empty-state-description')
    : t('home.custom-empty-state-description');

  return (
    <EmptyState
      icon={IconName.Home}
      title={title}
      text={text}
      actions={actions}
    />
  );
}
